const UserFacingAPIReturnTypes = Object.freeze({
  'error': 'error',
  'info': 'info',
  'success': 'success',
})

export default UserFacingAPIReturnTypes
